module.exports = __webpack_public_path__ + "media/images/background/1-f5464ffdff1e6ddbab92a1b0ad847445.jpg";